import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@frontend/unhideschool/app/core/services/auth.service';
import { UnhDialog } from '@frontend/unhideschool/shared/services/unh-dialog.service';
import { GoogleTagManagerService } from '@frontend/unhideschool/app/core/services/google-tag-manager.service';
import { environment } from '../../../../../environments/environment';
import { LoggedUserStateService } from '@frontend/unhideschool/app/core/services/legacy/logged-user.state';

@Component({
  selector: 'unh-handoff',
  template: '',
  styles: [''],
})
export class HandoffComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private unhDialog: UnhDialog,
    private luss: LoggedUserStateService,
    private gtmService: GoogleTagManagerService
  ) {}

  ngOnInit(): void {
    this.completeHandoff();
  }

  async completeHandoff(): Promise<void> {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        throw new Error('Token de handoff não encontrado na URL');
      }

      window.history.replaceState({}, document.title, window.location.pathname);

      const response = await fetch(
        environment.apipath + '/auth/handoff/exchange',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        }
      );

      const payload = await response.json();

      if (!response.ok || !payload.success) {
        const errorMessage =
          payload.reason || 'Falha no handoff de autenticação';

        if (response.status === 401 || response.status === 403) {
          throw new Error('Token inválido ou expirado. Acesso negado.');
        } else if (response.status === 0 || response.status >= 500) {
          throw new Error(
            'Serviço temporariamente indisponível. Tente novamente em instantes.'
          );
        } else {
          throw new Error(errorMessage);
        }
      }

      const unhideToken = payload.dict?.token;
      const unhideUser = payload.dict?.user;

      if (!unhideToken || !unhideUser) {
        throw new Error('Resposta inválida do servidor');
      }

      await this.authService.getAuthenticatedUserData(unhideToken).toPromise();

      this.luss.space = 'mySpace';

      this.gtmService.trackEvent('login_with_octodone');

      this.router.navigateByUrl('/carreiras');
    } catch (error) {
      console.error('Erro no handoff:', error);

      const errorMessage = (error as Error)?.message || 'Erro desconhecido';

      this.unhDialog
        .defaultConfirm({
          text: {
            title: 'Erro na autenticação',
            message: errorMessage,
          },
          buttons: [
            {
              text: 'Entendi',
              type: 'default',
              response: false,
            },
          ],
        })
        .subscribe(() => {
          this.router.navigate(['/home']);
        });
    }
  }
}
